// redux/log/log.actions.ts
import { createAsyncThunk } from '@reduxjs/toolkit';

import LogAPI from '@/api/log';

import type { GetLogsParams, LogEntry, LOGS_GET_ALL, LOGS_GET_CLIENTS_LOG } from './log.types';
import type { LogItem } from './log.types';

type LogsPayload = LogEntry[] | { result: LogItem[]; total?: number };

const MAX_LIMIT = 200;

// GET /api/logs — поддержка обоих форматов
export const getLogs = createAsyncThunk<LogsPayload, GetLogsParams | undefined>(
  'LOGS_GET_ALL',
  async (params, { rejectWithValue }) => {
    try {
      const safe = params?.limit && params.limit > MAX_LIMIT ? { ...params, limit: MAX_LIMIT } : params;

      const res = await LogAPI.get(safe);
      return res.data as LogsPayload;
    } catch (err: any) {
      return rejectWithValue(err?.response?.data || 'Ошибка загрузки логов');
    }
  },
);

export const getClientLog = createAsyncThunk<LogsPayload, Record<string, any>>(
  'LOGS_GET_CLIENTS_LOG',
  async (params, { rejectWithValue }) => {
    try {
      const res = await LogAPI.getClientLogs(params);
      return res.data as LogsPayload;
    } catch (err: any) {
      return rejectWithValue(err?.response?.data || 'Ошибка загрузки клиентских логов');
    }
  },
);
